import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function toFirstLettersUppercase(value: string, delimiter = "_"): string {
    return value
      .split(delimiter)
      .map((word) => word && `${word[0].toUpperCase()}${word.substring(1)}`)
      .join(" ");
  }

  return {
    toFirstLettersUppercase,
  };
}
